import { Console } from "console";
import { GenerateBillValidateProps, LoginValidateProps, MachineDefinitionValidateProps, MachineInstallRequestValidateProps, ManualPaymentValidateProps, NewPaymentGetwayValidateProps, NoValidateProps, PadvishRequestLicenseValidateProps, PadvishRequestValidateProps, ParsinkConfigValidateProps, TaxInfoValidateProps, TemperatureInstallRequestValidateProps, UpdatePasswordValidateProps } from "./types";
import { NationalCodeValidation } from "../components/_common/Validations/Index";


export function NoValidateForm(values: NoValidateProps) {
  let errors = {} as NoValidateProps;
  return errors;
}


export function validateLoginForm(values: LoginValidateProps) {
  let errors = {} as LoginValidateProps;

  if (!values.userName) {
    errors.userName = "نام کاربری اجباری است";
  }
  if (!values.password) {
    errors.password = "گذر واژه اجباری است";
  }
  return errors;
}

export function validateNewPaymentGetwayForm(values: NewPaymentGetwayValidateProps) {
  let errors = {} as NewPaymentGetwayValidateProps;
  var phonenoReg = /(0|\+98)?([ ]|-|[()]){0,2}9[0-9]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/ig;

    if (!values.customerName) {
      errors.customerName = "نام اجباری است";
    }
    if (!values.fatherName) {
      errors.fatherName = "نام پدر اجباری است";
    }
    
    if (!values.brithDay) {
      errors.brithDay = " تاریخ تولد اجباری است";
    }
    if (!values.identityId) {
      errors.identityId = " شماره شناسنامه اجباری است";
    }
    if (!values.identityserialnumber) {
      errors.identityserialnumber = " سریال شناسنامه اجباری است";
    }
    if (!values.directTel) {
      errors.directTel = " شماره تماس اجباری است";
    }
    if (!values.mobileNumber) {
      errors.mobileNumber = " شماره موبایل اجباری است";
    }
    else if (!values.mobileNumber.match(phonenoReg)) {
      errors.mobileNumber = " شماره موبایل معتبر نیست";
    }
    if (!values.email) {
      errors.email = " ایمیل اجباری است";
    }
    else if(!values.email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
      errors.email = " ایمیل معتبر نیست";
    }
    if (!values.accountownername) {
      errors.accountownername = " نام صاحب حساب اجباری است";
    }
    if (!values.accountNumber) {
      errors.accountNumber = " شماره حساب اجباری است";
    }
    if (!values.shabaNumber) {
      errors.shabaNumber = " شماره شبا اجباری است";
    }
    if (values.isCompany) {
      if (!values.nationalCode) {
        errors.nationalCode = " شناسه ملی اجباری است";
      }
      if (!values.ceoName) {
        errors.ceoName = " نام مدیر عامل اجباری است";
      }
      if (!values.ceoNationalCode) {
        errors.ceoNationalCode = " کد ملی مدیر عامل اجباری است";
      }
      else if(!NationalCodeValidation(values.ceoNationalCode)){
        errors.ceoNationalCode = " کد ملی معتبر نیست";
      }
      if (!values.registrationNumber) {
        errors.registrationNumber = " شماره ثبت شرکت اجباری است";
      }
      if (!values.companyRegistrationDate) {
        errors.companyRegistrationDate = " تاریخ ثبت شرکت اجباری است";
      }
  }
  else{
    if (!values.nationalCode) {
      errors.nationalCode = " کد ملی اجباری است";
    }
    else if(!NationalCodeValidation(values.nationalCode)){
      errors.nationalCode = " کد ملی معتبر نیست";
    }
  }

  return errors;
}


export function MachineInstallRequestForm(values: MachineInstallRequestValidateProps) {
  let errors = {} as MachineInstallRequestValidateProps;

  if (!values.mobile) {
    errors.mobile = "ورود موبایل اجباری است";
  }
  else {
    if (values.mobile.length !== 11) {
      errors.mobile = "شماره موبایل وارد شده صحیح نمی باشد";
    }
  }

  return errors;
}

export function TemperatureInstallRequestForm(values: TemperatureInstallRequestValidateProps) {
  let errors = {} as TemperatureInstallRequestValidateProps;

  if (!values.mobile) {
    errors.mobile = "ورود موبایل اجباری است";
  }
  else {
    if (values.mobile.length !== 11) {
      errors.mobile = "شماره موبایل وارد شده صحیح نمی باشد";
    }
  }

  return errors;
}

export function PadvishRequestForm(values: PadvishRequestValidateProps) {
  let errors = {} as PadvishRequestValidateProps;

  if (!values.mobile) {
    errors.mobile = "ورود موبایل اجباری است";
  }
  else {
    if (values.mobile.length !== 11) {
      errors.mobile = "شماره موبایل وارد شده صحیح نمی باشد";
    }
  }

  return errors;
}

export function PadvishRequestLicenseForm(values: PadvishRequestLicenseValidateProps) {
  let errors = {} as PadvishRequestLicenseValidateProps;

  if (!values.licenseCount) {
    errors.licenseCount = "ورود تعداد کاربر اجباری است";
  }

  return errors;
}

export function validateMachineDefinitionForm(values: MachineDefinitionValidateProps) {
  let errors = {} as MachineDefinitionValidateProps;

  if (!values.machineCode) {
    errors.machineCode = "ورود کد داخلی اجباری است";
  }

  if (!values.name) {
    errors.name = "ورود نام اجباری است";
  }

  // if (values.hasDriver === 0) {
  //   errors.name = "آپلود درایور اجیاری است";
  // }

  // if (values.hasDriver === false) {
  //   errors.name = "آپلود درایور اجیاری است";
  // }

  return errors;
}


export function ManualPaymentForm(values: ManualPaymentValidateProps) {
  let errors = {} as ManualPaymentValidateProps;

  return errors;
}


export function validateTaxInfoForm(values: TaxInfoValidateProps) {
  let errors = {} as TaxInfoValidateProps;

  if (!values.str_TaxnationalCode) {
    errors.str_TaxnationalCode = "ورود کد ملی آزمایشگاه یا مالک آن اجباری است";
  }

  if (values.str_TaxnationalCode === "") {
    errors.str_TaxnationalCode = "ورود کد ملی آزمایشگاه یا مالک آن اجباری است";
  }

  if (!values.str_Economicode) {
    errors.str_Economicode = "ورود کد اقتصادی اجباری است";
  }

  if (values.str_Economicode === "") {
    errors.str_Economicode = "ورود کد اقتصادی اجباری است";
  }

  if (!values.str_TaxFullNameOwnernationalCode) {
    errors.str_TaxFullNameOwnernationalCode = "ورود نام کامل آزمایشگاه یا مالک آن اجباری است";
  }

  if (values.str_TaxFullNameOwnernationalCode === "") {
    errors.str_TaxFullNameOwnernationalCode = "ورود نام کامل آزمایشگاه یا مالک آن اجباری است";
  }

  if (!values.str_PostalCode) {
    errors.str_PostalCode = "ورود کد پستی اجباری است";
  }

  if (values.str_PostalCode === "") {
    errors.str_PostalCode = "ورود کد پستی اجباری است";
  }

  if (!values.Str_DirectTel) {
    errors.Str_DirectTel = "ورود کد پستی اجباری است";
  }

  if (values.Str_DirectTel === "") {
    errors.Str_DirectTel = "ورود کد پستی اجباری است";
  }

  if (!values.Str_Address) {
    errors.Str_Address = "ورود آدرس پستی اجباری است";
  }

  if (values.Str_Address === "") {
    errors.Str_Address = "ورود آدرس پستی اجباری است";
  }

  return errors;
}


export function validateUpdatePasswordForm(values: UpdatePasswordValidateProps) {
  let errors = {} as UpdatePasswordValidateProps;

  if (!values.oldPassword) {
    errors.oldPassword = "ورود گذرواژه قدیمی اجباری است";
  }

  if (values.oldPassword === "") {
    errors.oldPassword = "ورود گذرواژه قدیمی اجباری است";
  }

  if (!values.newPassword) {
    errors.newPassword = "ورود گذرواژه جدید اجباری است";
  }

  if (values.newPassword === "") {
    errors.newPassword = "ورود گذرواژه جدید اجباری است";
  }

  if (!values.repeatNewPassword) {
    errors.repeatNewPassword = "ورود تکرار گذرواژه جدید اجباری است";
  }

  if (values.repeatNewPassword === "") {
    errors.repeatNewPassword = "ورود تکرار گذرواژه جدید اجباری است";
  }

  if (values.newPassword != values.repeatNewPassword) {
    errors.repeatNewPassword = "گذرواژه وارد شده با تکرار آن برابر نمی باشد";
  }

  return errors;
}


export function validategenerateBillForm(values: GenerateBillValidateProps) {
  let errors = {} as GenerateBillValidateProps;


  if (!values.title) {
    errors.title = "عنوان فاکتور اجباری است";
  }

  if (values.title === "") {
    errors.title = "عنوان فاکتور اجباری است";
  }

  if (!values.amount) {
    errors.title = "مبلغ فاکتور اجباری است";
  }

  if (Number(values.amount) <= 0) {
    errors.title = "مبلغ فاکتور نمیتواند صفر باشد";
  }


  return errors;
}

export function ParsinkConfigForm(values: ParsinkConfigValidateProps) {
  let errors = {} as ParsinkConfigValidateProps;

  if (!values.sqlInstance) {
    errors.sqlInstance = "ورود موبایل اجباری است";
  }
 
  return errors;
}
